import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import AttenderA from '@assets/svg/attender_a.svg';
import ExclamationIcon from '@assets/svg/exclamation.svg';

export const FilterMenu = styled.div<{open:boolean}>`
  position: fixed;
  top: 0;
  right: ${props => props.open?"0":"-31.74vw"};
  width: 31.74vw;
  height: 100vh;
  background-color: ${props => props.theme.colors.red};
  z-index: 227;
  transition: all 0.4s ease-in-out;

  ${mq(Devices.laptop)} {
    width: 50vw;
    right: ${props => props.open?"0":"-50vw"};
  }

  ${mq(Devices.tablet)} {
    right: ${props => props.open?"0":"-100%"};
    width: var(--document-width);
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  padding: 10px;
  top: 21px;
  right: calc(var(--padding) - 10px);

  svg {
    margin: auto;
    width: 20px;
    fill: ${props => props.theme.colors.white};
    transform: rotate(45deg);
  }

  ${mq(Devices.tablet)} {
    top: 21px;
  }
`;

export const Backdrop = styled(AttenderA)`
  position: absolute;
  bottom: 0;
  right: -1.5vw;
  opacity: 0.2;
  width: 17.6vw;
  z-index: 1;

  ${mq(Devices.tablet)} {
    width: 50vw;
  }

  path {
    fill: ${props => props.theme.colors.white};
  }
`;


export const Content = styled.div`
  position: relative;
  margin-top: 10.67vh;
  padding-left: 7.04vw;
  padding-right: 3.04vw;
  padding-bottom: 2.04vw;

  ${mq(Devices.tablet)} {
    margin-top: 20.91vh;
    padding-left: 11vw;
    padding-right: 11vw;
    padding-bottom: 11vw;
  }
`;

export const HeaderText = styled.h3`
  font-size: 24px;
  font-weight: 500;
  color:#fff;
  margin-top: 20px;
  
  span {
   color: ${props => props.theme.colors.buttonHoverColor}
  }

  &:nth-child(1){
    margin-bottom: 10px;
  }

  > div{
    display:inline-block;
  }
`;  

export const SelectButton = styled.button<{active?:boolean, disabled?:boolean}>`
  background:${props => props.active?props.theme.colors.buttonHoverColor:"#fff"};
  padding:7px 10px;
  min-width:120px;
  width:60%;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  color:${props => props.active?"#fff":"#000"};  
  cursor: ${props => props.disabled?"not-allowed":"pointer"}!important;
  :hover{
    background: ${props => props.theme.colors.buttonHoverColor};
    color:#fff;
  }
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${props => props.theme.fontSizes.medium}px;
  justify-content: start;
  z-index: 2 !important;
  min-width:120px;
  width: 60%;

  p{
    font-weight: 400;
    cursor: default;
    color:#fff;
    margin-top: 5px;
  }
  
  &:nth-child(1){
    z-index: 4 !important;
  }
`;

export const DateSelectButton = styled(SelectButton)`
  margin-top: 10px;
  text-align: center;
`;

export const DateSelectContainer = styled.div`
  width:100%;

  
`;

export const Exclamation = styled(ExclamationIcon)`
  height: auto;
  width:22px;
  margin-left:10px;

  path{
    fill:#fff;
  }
`;